import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { HardDrive, Loader2, Check } from "lucide-react";

const DRIVE = `${process.env.REACT_APP_BACKEND_URL}/api/drive`;

export const DriveExportButton = ({ item }) => {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState((item.drive_exports || []).length > 0);
  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${DRIVE}/export/${item.id}`, {}, { timeout: 300000 });
      setDone(true);
      toast.success("Trimis în Google Drive", { action: { label: "Deschide", onClick: () => window.open(r.data.link, "_blank") } });
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <button data-testid={`gallery-drive-${item.id}`} title={done ? "Trimis deja în Google Drive — trimite din nou" : "Trimite în Google Drive"} onClick={go} disabled={busy}
      className={`rounded p-1.5 hover:bg-zinc-800 ${done ? "text-emerald-400" : "text-zinc-400 hover:text-amber-400"}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : done ? <Check className="h-4 w-4" /> : <HardDrive className="h-4 w-4" />}
    </button>
  );
};
